import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "textarea", "feedback", "tab", "pane"]

  open() {
    this.dialogTarget.showModal()
  }
  close() {
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  activate(event) {
    const tab = event.currentTarget.dataset.tab
    this.tabTargets.forEach((t) => {
      const active = t.dataset.tab === tab
      t.classList.toggle("border-vivid-purple", active)
      t.classList.toggle("text-app-text", active)
      t.classList.toggle("border-transparent", !active)
      t.classList.toggle("text-app-text-muted", !active)
      t.setAttribute("aria-selected", String(active))
    })
    this.paneTargets.forEach((p) => {
      p.hidden = p.dataset.tab !== tab
    })
  }

  validate(event) {
    const raw = this.textareaTarget.value.trim()
    if (!raw) {
      event.preventDefault()
      return
    }

    const emails = raw.split(/[\s,]+/).filter(Boolean)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const invalid = emails.filter((e) => !emailRegex.test(e))

    if (invalid.length > 0) {
      event.preventDefault()
      this.feedbackTarget.innerHTML = `<div class="rounded-md bg-red-50 p-3 mt-3"><p class="text-sm text-red-800">Invalid email${invalid.length > 1 ? "s" : ""}: ${invalid.join(", ")}</p></div>`
    }
  }

  resetOnSuccess(event) {
    if (event.detail.success) this.textareaTarget.value = ""
  }
}
